import { render, staticRenderFns } from "./AppResourceKeywords.vue?vue&type=template&id=3166e21a&scoped=true"
import script from "./AppResourceKeywords.vue?vue&type=script&lang=js"
export * from "./AppResourceKeywords.vue?vue&type=script&lang=js"
import style0 from "./AppResourceKeywords.vue?vue&type=style&index=0&id=3166e21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166e21a",
  null
  
)

export default component.exports